// src/components/Footer.js
import React from "react";
import {
  FaFacebookF,
  // FaTwitter,
  // FaInstagram,
  // FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-10">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* About Section */}
        <div className="mb-6">
          <h3 className="text-lg font-bold mb-3">
            About Radiant Model Academy
          </h3>
          <p className="text-gray-400">
            Radiant Model Academy is dedicated to providing a high-quality
            education that prepares students to excel in science and technology.
            Our mission is to foster innovation and curiosity in the minds of
            future leaders.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="mb-6">
          <h3 className="text-lg font-bold mb-3">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="/about"
                className="text-gray-400 hover:text-white transition"
              >
                About Us
              </a>
            </li>
            {/* <li>
              <a
                href="/programs"
                className="text-gray-400 hover:text-white transition"
              >
                Our Programs
              </a>
            </li> */}
            <li>
              <a
                href="/contact"
                className="text-gray-400 hover:text-white transition"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Information Section */}
        <div>
          <h3 className="text-lg font-bold mb-3">Get In Touch</h3>
          <p className="text-gray-400 mb-2 text-center">
            <strong>Email:</strong> radiantmodelacademy@gmail.com
          </p>
          <p className="text-gray-400 mb-2">
            <strong>Phone:</strong>
            <a
              href="tel:+2348033692734"
              className="text-blue-500 hover:underline"
            >
              +234 813-497-8544
            </a>
          </p>

          <p className="text-gray-400">
            <strong>Address:</strong> ilorin, Kwara State, Nigeria.
          </p>
        </div>
      </div>

      {/* Social Media Section */}
      <div className="border-t border-gray-700 mt-8 py-6">
        <div className="flex justify-center space-x-6">
          <a
            href="https://www.facebook.com/"
            className="text-gray-400 hover:text-white transition"
            aria-label="Facebook"
          >
            <FaFacebookF size={20} />
          </a>
          <a
            href="https://www.youtube.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-red-600 hover:underline"
          >
            <FaYoutube className="mr-2 text-2xl" />
            Visit our YouTube channel
          </a>

          {/* <a
            href="https://twitter.com"
            className="text-gray-400 hover:text-white transition"
            aria-label="Twitter"
          >
            <FaTwitter size={20} />
          </a>
          <a
            href="https://instagram.com"
            className="text-gray-400 hover:text-white transition"
            aria-label="Instagram"
          >
            <FaInstagram size={20} />
          </a>
          <a
            href="https://linkedin.com"
            className="text-gray-400 hover:text-white transition"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn size={20} />
          </a> */}
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="bg-gray-800 text-center py-4">
        <p className="text-gray-500">
          &copy; {new Date().getFullYear()} Radiant Model Academy. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
